import type { NetworkId } from '@/features/loader/types';

export const NETWORKS: { id: NetworkId; label: string; group: 'core' | 'profiles' | 'live' }[] = [
  { id: 'full_catalogue', label: 'Full Catalogue', group: 'live' },
  { id: 'noaa', label: 'NOAA NESDIS', group: 'core' },
  { id: 'noaa_extended', label: 'Extended Earth-observation planning', group: 'profiles' },
  { id: 'nasa', label: 'NASA NSN', group: 'profiles' },
  { id: 'spaceforce', label: 'Space Force SCN', group: 'profiles' },
  { id: 'artemis', label: 'Artemis II DSN', group: 'profiles' },
  { id: 'mars', label: 'Mars DSN', group: 'profiles' },
  { id: 'rfims', label: 'RFIMS · live monitoring', group: 'profiles' },
  { id: 'starlink', label: 'Starlink (live)', group: 'live' },
  { id: 'oneweb', label: 'OneWeb (live)', group: 'live' },
  { id: 'stations', label: 'ISS and Tiangong (live)', group: 'live' },
  { id: 'gnss', label: 'GNSS (live)', group: 'live' },
  { id: 'sentinel', label: 'Sentinel (live)', group: 'live' },
  { id: 'satnogs', label: 'SatNOGS (live)', group: 'live' },
  { id: 'aws_ground_station', label: 'AWS Ground Station', group: 'live' },
];
